// extracted by mini-css-extract-plugin
export default {"loader":"_3ph305Q5glFGcgXSpOZlvl","tableRow":"_3RxHSewWqUp8eAGZYsdK6h","noWrap":"_3cqsA8tTso9X8H1Ht0-uj8","buttons-div":"_2wDEXbKc43MtsvgjR4g5dn"};